<template lang="pug">
  .table-data
    table.striped.table-data( :data-name="tbName")
      thead
        tr
          th Nombre 
          th.center Editar
          th.center Eliminar
      tbody
        tr( v-for="(item, $i) in datosValues" :key="item.id")
          td {{item.name}}
          td.center
            a.waves-effect.waves-light.btn.light-blue.darken-4( @click="sendEmit(tbName,'edit',item.id,$i) ")
              i.material-icons edit
          td.center
            a.waves-effect.waves-light.btn.red.darken-4( @click="sendEmit(tbName,'delete',item.id,$i) ")
              i.material-icons delete_forever  
        tr.no-color
          td.no-border.full-right( colspan="3")
            a.green.darken-4.waves-effect.waves-light.btn.mtb-50( @click="sendEmit(tbName,'add-new' ) ") 
              i.material-icons.left add 
              | Nuevo
</template>
<style lang="scss" scoped>
.no-color{ background: transparent;}
.mtb-50{
  margin-top: 50px;
  margin-bottom: 50px;
}
.full-right{
  text-align: right !important;
}
.no-border{
  border:inherit;
}
.table-data{
  max-height: 570px;
  overflow-y: scroll;
}
thead{
  & tr{
    border: 2px solid #424242;
    line-height: 30px;
    font-size: 16px;
    background-color: rgb(61, 61, 61);
    color: white;
    font-family: sans-serif;
    
    & th{
      border: 2px solid #424242;
      position: -webkit-sticky; // this is for all Safari (Desktop & iOS), not for Chrome
      position: sticky;
      top: 0;
      z-index: 5;
      background-color: rgb(61, 61, 61);
    }
  }
  
}

td{
  padding: 5px;
  border: 1px #000 dotted;
}
.center{
  text-align: center;
}
</style>
<script>
export default {
  props:{
    datosValues : { type:  Array, default:[]},
    tbName  : { type: String, required: true }
  },
  data() {
    return {
     
    }
  },
  methods: {
    activeEdit(_e) {
      console.log(_e);
    },
    getData() {

    },  
    sendEmit(_name,_action,_id, $i) {
      // console.log("Emitiendo valores: ", { "name":_name ,"action":_action, "id":_id, "index": $i });
      if(_action === 'add-new' )
        this.$emit("ModifyData",{ "name":_name ,"action":_action });
      else
        this.$emit("ModifyData",{ "name":_name ,"action":_action, "id":_id, "index": $i });
    },
  },
  created (){
    // this.getData();
  }
}
</script>